import Grid from '@mui/material/Grid';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { Division } from '../../../models/masters/division';

interface IDivisionForm {
  editItem?: Partial<Division> | undefined;
}
export const DivisionForm = ({ editItem }: IDivisionForm) => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput
          label="Division Name"
          name="divisionName"
          maxLength={150}
          autoFocus
          disabled={!!editItem?.divisionID}
        />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Description" name="description" maxLength={150} multiline={true} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
        <FormCheckbox label="Send Email Reminder" name="sendEmailReminder" />
          <FormCheckbox label="Active" name="isActive" />
        </Grid>
      </Grid>
    </Grid>
  );
};
